<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!--법령-->
          <c-select
            codeGroupCd="LAW_ID"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="lawId"
            label="LBL0010071"
            v-model="searchParam.lawId"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            :comboItems="curHistroyItems"
            itemText="codeName"
            itemValue="code"
            label="현행/연혁"
            name="curHistroyCode"
            v-model="searchParam.curHistroyCode">
          </c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 공포기간 -->
          <c-datepicker
            :range="true"
            defaultStart="-2y"
            defaultEnd="2M"
            label="LBL0010103"
            name="promulgationPeriod"
            v-model="searchParam.promulgationPeriod"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
        </div>
      </template>
    </c-search-box>
    <!--법령 목록-->
    <c-table
      title="LBL0010096"
      tableId="safetyControlDangerous"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'oldAndNew' || (col.name === 'custom' && props.row.lawLink)">
          <q-icon
            class="tableinnerBtn cursor-pointer"
            name="launch"
            color="blue-6"
            size="sm"
            @click.stop="linkClick(props, col)" />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'safety-control-dangerous',
  data() {
    return {
      searchParam: {
        promulgationPeriod: [],
        lawId: null,
        curHistroyCode: null,
      },
      curHistroyItems: [ // 사용여부
        { code: '연혁', codeName: '연혁' },
        { code: '시행예정', codeName: '시행예정' },
        { code: '현행', codeName: '현행' },
      ],
      grid: {
        columns: [
          {
            name: 'lawSerialNum',
            field: 'lawSerialNum',
            //법령일련번호
            label: 'LBL0010097',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
          {
            name: 'curHistroyCode',
            field: 'curHistroyCode',
            //현행연혁코드
            label: 'LBL0010098',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'lawNameKor',
            field: 'lawNameKor',
            //법령명한글
            label: 'LBL0010079',
            align: 'left',
            sortable: true,
            style: 'width:200px',
          },
          {
            name: 'lawNameAbb',
            field: 'lawNameAbb',
            //법령약칭명
            label: 'LBL0010080',
            align: 'left',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'revisionTypeName',
            field: 'revisionTypeName',
            //제개정구분명
            label: 'LBL0010099',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'competentMinistriesName',
            field: 'competentMinistriesName',
            //소관부처명
            label: 'LBL0010100',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'lawClassNameReal',
            field: 'lawClassNameReal',
            //법령구분명
            label: 'LBL0010101',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'promulgationDate',
            field: 'promulgationDate',
            //공포일자
            label: 'LBL0010081',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
          {
            name: 'enforcementDate',
            field: 'enforcementDate',
            //시행일자
            label: 'LBL0010085',
            align: 'center',
            sortable: true,
            style: 'width:80px',
          },
          // {
          //   name: 'lawTypeFlag',
          //   field: 'lawTypeFlag',
          //   label: '자법타법여부',
          //   align: 'center',
          //   sortable: false,
          //   style: 'width:80px',
          // },
          {
            name: 'reasonText',
            field: 'reasonText',
            label: '재개정사유',
            align: 'left',
            sortable: false,
            style: 'width:100px',
            isEllipsis: true,
            maxWidth: '100px'
          },
          {
            name: 'oldAndNew',
            field: 'oldAndNew',
            label: '신구법비교',
            align: 'center',
            sortable: false,
            headerStyle: 'width:50px',
            type: 'custom'
          },
          {
            name: 'custom',
            field: 'custom',
            label: '법령상세',
            align: 'center',
            sortable: false,
            style: 'width:50px',
            type: 'custom'
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.law.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(props, col) {
      if (col.name === 'custom') {
        window.open('https://www.law.go.kr' + props.row.lawLink, '법규', 'width=1200, height=800');
      }
      if (col.name === 'oldAndNew') {
        if (props.row.lawClassName === '행정규칙') {
          window.open(
            `https://www.law.go.kr/DRF/lawService.do?OC=${props.row.oc}&target=admrulOldAndNew&ID=${props.row.lawSerialNum}&type=HTML`,
            '신구법 비교',
            'width=1200,height=800'
          )
        } else {
          window.open(
            `https://www.law.go.kr/DRF/lawService.do?OC=${props.row.oc}&target=oldAndNew&MST=${props.row.lawSerialNum}&type=HTML`,
            '신구법 비교',
            'width=1200,height=800'
          )
        }
      }
    }
  }
};
</script>
